var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.5 407.5",
    style: {
      enableBackground: "new 0 0 407.5 407.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.1,116.5c4.5,0,8.1-3.6,8.1-8.1c0-4.5-3.6-8.1-8.1-8.1H143.5c-4.5,0-8.1,3.6-8.1,8.1 c0,4.5,3.6,8.1,8.1,8.1H255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.1,100.3h-55.4c-4.5,0-8.1,3.6-8.1,8.1c0,4.5,3.6,8.1,8.1,8.1h47.2v274.7H48.5V116.5h44.5 c4.5,0,8.1-3.6,8.1-8.1c0-4.5-3.6-8.1-8.1-8.1H40.4c-4.5,0-8.1,3.6-8.1,8.1v290.9c0,4.5,3.6,8.1,8.1,8.1h326.7 c4.5,0,8.1-3.6,8.1-8.1V108.4C375.2,103.9,371.6,100.3,367.1,100.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.6,134.8c4.5,0,8.1-3.6,8.1-8.1V67.4c0-37.2-40.1-67.4-89.6-67.4c-49.3,0-89.4,30.2-89.4,67.4v59.3 c0,4.5,3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1V67.4c0-28.2,32.8-51.1,73.4-51.1c40.3,0,73.2,22.9,73.2,51.1v59.3 C274.5,131.2,278.1,134.8,282.6,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.9,147.6c0,11.5,9.4,20.9,20.9,20.9s20.9-9.4,20.9-20.9c0-4.5-3.6-8.1-8.1-8.1s-8.1,3.6-8.1,8.1 c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.7-2.1-4.7-4.6c0-4.5-3.6-8.1-8.1-8.1S98.9,143.1,98.9,147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.6,168.5c11.5,0,20.9-9.4,20.9-20.9c0-4.5-3.6-8.1-8.1-8.1s-8.1,3.6-8.1,8.1c0,2.6-2.1,4.6-4.7,4.6 s-4.7-2.1-4.7-4.6c0-4.5-3.6-8.1-8.1-8.1s-8.1,3.6-8.1,8.1C261.7,159.1,271.1,168.5,282.6,168.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shoppingBag.f08574c3.svg";
export { ForwardRef as ReactComponent };